import { Container, Grid, Typography } from '@material-ui/core'
import styled from 'styled-components'
import { rem } from '../../utils/rem'
import { GlossaryCard } from '../../components/glossary/GlossaryCard'

// Glossary content section
export const StyledGlossaryContentWrapper = styled(Grid)`
  width: 100%;
  position: relative;
  margin-top: ${props => props.theme.typography.pxToRem(50)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(60)};
  }
  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(80)};
  }
`

export const StyledGlossaryHeader = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: 500;
  text-align: center;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(22)};
    text-align: left;
    margin-bottom: ${props => props.theme.typography.pxToRem(30)};
  }
  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: ${props => props.theme.typography.pxToRem(95)};
  }
`

// Contact CTA section
export const StyledContactCTAWrapper = styled(Grid)`
  width: 100%;
  position: relative;
`

// Popular guide articles section
export const StyledPopularGuideArticlesHeader = styled(Typography)`
  text-align: center;
  margin-bottom: ${props => props.theme.typography.pxToRem(35)};
  font-size: ${props => props.theme.typography.pxToRem(15)};
  font-weight: 500;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-bottom: ${props => props.theme.typography.pxToRem(84)};
  }
`

export const StyledPopularGuideArticlesWrapper = styled(Grid)`
  width: 100%;
  padding-left: ${props => props.theme.typography.pxToRem(15)};
  padding-right: ${props => props.theme.typography.pxToRem(15)};
  margin-top: ${props => props.theme.typography.pxToRem(15)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(80)};
    padding-left: 0;
  }
`

// Disclaimer section
export const StyledDisclaimerWrapper = styled(Grid)`
  width: 100%;
  padding-left: ${props => props.theme.typography.pxToRem(15)};
  padding-right: ${props => props.theme.typography.pxToRem(15)};
  margin-top: ${props => props.theme.typography.pxToRem(96)};
  margin-bottom: ${props => props.theme.typography.pxToRem(83)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(158)};
    margin-bottom: ${props => props.theme.typography.pxToRem(113)};
    padding-left: 0;
    padding-right: 0;
  }

  h5[class*="styleddisclaimer__StyledDisclaimerTitle"] {
    text-align: center;
    margin-bottom: ${props => props.theme.typography.pxToRem(30)};
    ${props => props.theme.breakpoints.up('sm')} {
      margin-bottom: ${props => props.theme.typography.pxToRem(25)};
    }
    ${props => props.theme.breakpoints.up('md')} {
      text-align: left;
    }
  }
`

// Page container
export const StyledGreyBackground = styled(Container)`
  position: relative;
  padding-bottom: ${props => rem(100, props.theme)};

  > section {
    width: 100%;
  }

  &::before {
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f2f2f2;
    position: absolute;
    z-index: -1;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - ${props => rem(350, props.theme)}), 0 calc(100% - ${props => rem(490, props.theme)}));

    ${props => props.theme.breakpoints.up('sm')} {
      clip-path: polygon(0 0, 100% 0, 100% calc(100% - ${props => rem(130, props.theme)}), 0 calc(100% - ${props => rem(300, props.theme)}));
    }
  }
`
export const GlossaryWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-left: ${props => props.theme.typography.pxToRem(10)};
  padding-right: ${props => props.theme.typography.pxToRem(10)};
  padding-bottom: ${props => props.theme.typography.pxToRem(60)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: ${props => props.theme.typography.pxToRem(195)};
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`
export const GlossaryImageWrapper = styled(GlossaryCard)`
  height: ${props => props.theme.typography.pxToRem(180)};
  overflow: unset;

  ${props => props.theme.breakpoints.up('sm')} {
    height: auto;
  }
`

export const StyledGlossaryPageContainer = styled.div`
  div[class*="SecondaryBanner__StyledContentContainer"] {
    > [class*="StyledSecondaryBanner__StyledTitle"] {
      font-size: ${props => props.theme.typography.pxToRem(20)};

      ${props => props.theme.breakpoints.up('sm')} {
        font-size: ${props => props.theme.typography.pxToRem(24)};
      }
    }

    > [class*="StyledSecondaryBanner__StyledSubtitle"] {
      font-size: ${props => props.theme.typography.pxToRem(30)};
      font-weight: 500;
      margin: ${props => props.theme.typography.pxToRem(8)} 0 0 0;

      ${props => props.theme.breakpoints.up('sm')} {
        margin: 0;
        font-size: ${props => props.theme.typography.pxToRem(38)};
      }
    }
  }

  > [class*="secondaryPageBanner__StyledWrapper"]::after {
    opacity: 1;
  }
`